/**
 * Filter clear function
 */

export default function() {
  const clearBtn = $('.js-filter-clear');
  const checkboxContainer = $('.facetwp-type-checkboxes');
  const checkbox = $('.facetwp-checkbox');

  clearBtn.click(function (e) {
    e.preventDefault();

    checkboxContainer.each(function() {
      FWP.reset();
    })
  });
}